module.exports = __webpack_public_path__ + "Mark-Simonson-Proxima-Nova-Semibold-webfont.7bd0a4c62609f996460b.ttf";


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/src/styles/fonts/ProximaNova/Mark-Simonson-Proxima-Nova-Semibold-webfont.ttf
// module id = ../../../../../src/styles/fonts/ProximaNova/Mark-Simonson-Proxima-Nova-Semibold-webfont.ttf
// module chunks = main styles